import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Button, Modal, Row } from 'react-bootstrap'
import InputMoney from '../../../../components/commons/form/InputMoney'
import InputSelect from '../../../../components/commons/form/InputSelect'

class UACAppraisalWithTAXModal extends Component {
  constructor (props) {
    super()
    this.state = {
      taxquantity: 0,
      UACamountWithoutTax: 0,
      impor: 0
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.showModal && nextProps.showModal) {
      this.props.actions.change('UACivaType', this.props.valueCombo || nextProps.valueCombo)
      this.props.ivaTypeCombo.filter((value, indx) => {
        if ((this.props.valueCombo || nextProps.valueCombo) === value.id) {
          this.setState({ taxquantity: value.amountValue + 1 })
        }
      })
    }
  }

  handleBlurAmount (value) {
    this.props.actions.change('UACamountWithoutTax', (value / this.state.taxquantity).toFixed(2))
    this.setState({ UACamountWithoutTax: (value / this.state.taxquantity).toFixed(2) })
  }

  saveWithoutTax () {
    this.props.actions.change('amount', this.state.UACamountWithoutTax)
  }

  render () {
    const { t, showModal, actions: { closeModal }, ivaTypeCombo } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ECONOMIC_PLAN.MODAL_TAXES.'
    return (
      <Modal className='_nf UACAppraisalWithTAXModal' show={showModal} onHide={() => { closeModal() }}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='fieldsContainer'>
            <Field
              component={InputMoney}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="UACamountWithTax"
              name="UACamountWithTax"
              controlLabel={t(`${tKey}AMOUNT_WITH_TAX`)}
              placeholder={t(`${tKey}AMOUNT_WITH_TAX`)}
              onInputBlur={(value) => this.handleBlurAmount(value)}
            />
            <Field
              component={InputMoney}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="UACamountWithoutTax"
              name="UACamountWithoutTax"
              controlLabel={t(`${tKey}AMOUNT_WITHOUT_TAX`)}
              placeholder={t(`${tKey}AMOUNT_WITHOUT_TAX`)}
              disabled={true}
            />
            <Field
              component={InputSelect}
              colWidth={50} // 25, 33, 50, 75, 100 default=25
              id="UACivaType"
              name="UACivaType"
              valueKey="id"
              labelKey="value"
              controlLabel={t(`${tKey}SELECTED_TAX`)}
              placeholder={t(`${tKey}SELECTED_TAX`)}
              options={ivaTypeCombo}
              disabled={true}
              value={this.props.valueCombo}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="flexInLine al-C">
            <Button id="btn_save" className="_Btn accept" onClick={() => { this.saveWithoutTax(); closeModal() }} >{t(`${tKey}SAVE_BTN`)}</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default (UACAppraisalWithTAXModal)
